import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { CurrentUser } from '../services/current-user.service';
import { AuthConstants } from '../constants/auth.constant';
import { UrlPrefix } from "../constants/url-prefix.constants";

@Injectable()
export class CurrentUserResolverService  {

  constructor(
    public http: HttpClient,
    private currentUser: CurrentUser
  ) { }

  resolve() {
    if (!this.currentUser.isInit) {
      return this.http
        .get<any>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/users/current/data`)
        .toPromise()
        .then(userData => {
          this.currentUser.dateFormats.parse.dateInput = userData.dateFormat;
          this.currentUser.dateFormats.display.dateInput = userData.dateFormat;
          this.currentUser.domain = userData.domain;
          this.currentUser.isDefaultTenant = userData.domain.toLowerCase() === 'default';
          this.currentUser.id = userData.id;
          this.currentUser.userName = userData.username;
          this.currentUser.identityHash = userData.identityHash;
          this.currentUser.userType = userData.userType;
          this.currentUser.isInit = true;
          this.currentUser.isResponseDesignOn = userData.isResponseDesignOn;
          this.currentUser.userInitials = userData.userInitials;
          this.currentUser.hiddenMenuItems = userData.hiddenMenuItems;
          this.currentUser.securityKey = userData.securityKey;
          this.currentUser.dictionaryISOCode = userData.dictionaryISOCode;
          this.currentUser.accessRights = userData.accessRights;
          this.currentUser.email = userData.email;
           this.currentUser.isEuAccessCamUser = userData.isEuAccessCamUser;
          if (!window[AuthConstants.userIdentityHash]) {
            window[AuthConstants.userIdentityHash] = this.currentUser.identityHash;
          }
        });
    }
  }
}
